// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import './registerServiceWorker'

import router from './router'
import './output.css'
import store from './vuex'
import axios from 'axios'
// 引用API文件
import api from './api/index'
// vuex
import '@/vuex/index' // 全局
import {hasPermission} from './promission.js' // 路由后台获取
import * as Echarts from 'echarts'
import message from "@/components/index"

Vue.use(message.register);
Vue.use(axios)
Vue.use(Echarts)
Vue.prototype.$echarts = Echarts
// 将API方法绑定到全局
Vue.prototype.$http = axios
Vue.prototype.$api = api
const headTheme = 'light' // 选择 light 或 blue
Vue.prototype.headTheme = headTheme
// Vue.prototype.$lodash = lodash
Vue.prototype.hasPerm = hasPermission
Vue.config.productionTip = false
// Vue.prototype.cloneDeep = function(data) {
//     return lodash.cloneDeep(data)
// }
Vue.prototype.setCookie = function(name, value, days) {
  try {
    // 先删除已存在的同名 cookie
    const existingCookie = this.getCookie(name)
    if (existingCookie) {
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/'
    }
    
    let cookieString = name + '=' + encodeURIComponent(value) + ';path=/'
    
    if (days && days > 0) {
      const date = new Date()
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
      cookieString += ';expires=' + date.toUTCString()
    }
    
    // 为了兼容现代浏览器的安全要求，添加SameSite属性
    cookieString += ';SameSite=Lax'
    
    document.cookie = cookieString
  } catch (error) {
    console.error('设置Cookie失败:', error)
  }
}
Vue.prototype.getCookie = function(name) {
  try {
    const cookies = document.cookie.split(';')
    
    for (let cookie of cookies) {
      const [cookieName, cookieValue] = cookie.trim().split('=')
      if (cookieName === name) {
        return decodeURIComponent(cookieValue || '')
      }
    }
    
    return null
  } catch (error) {
    console.error('获取Cookie失败:', error)
    return null
  }
}
Vue.prototype.formatDate = function (dateString) {
    const formattedDate = dateString.replace(/T/, ' ').replace(/\.000Z/, '');
    return formattedDate
}
/* eslint-disable no-new */
const vue = new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  data() {
    return {
      website: '我是全局变量'
    }
  },
  template: '<App/>'
})
export default vue
